module.exports = __webpack_public_path__ + "static/media/products.0e820d46.svg";